<template>
    <div class="fw-member">
        <div class="member-bt">
            <span class="bty">
                MEMBER | 会员
            </span>
            <div class="mbcon">
                <div class="mbtext">
                    <span class="text1">Hello</span>
                    <span class="text2">欢迎光临MEMBER</span>
                    <span class="text3">SCAN CODE LOGIN</span>
                </div>
                <span class="mb-btn" @click="tologin">
                    会员中心
                </span>
            </div>
        </div>
        <div class="zhongjian">
            <img src="./../../assets/saoma.png"/>
            <span class="saoma" @click="saoma">立即扫码</span>
        </div>
        <div class="hyzx">
            <div class="hyzx-s">
                <div class="bian"></div>
                <div class="zhong">
                    <van-icon name="apps-o" color="#D4237A" style="margin-bottom: -8px;"/>
                </div>
                <div class="bian"></div>
            </div>
            <div class="hyzx-x">
                <span class="hy-text">会员中心</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {delCookie, getCookie} from "../../utils/auth";
    import wx from 'weixin-js-sdk';

    export default {
        components: {},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                wxConfig: {},
            };
        },
        async created() {
            if (getCookie("fwUser")) {
                this.fwUser = JSON.parse(getCookie("fwUser"))
                this.userType = this.fwUser.userType
                if (this.userType == 5) {
                    this.$router.push('/mys')
                    return;
                } else {
                    delCookie("fwUser")
                }
            }
            document.title = "会员扫码绑定"
            this.getDept()
            this.getWxScan()
        },

        methods: {
            initializationWxConfig(wxConfig) {
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: wxConfig.appId, // 必填，公众号的唯一标识
                    timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
                    nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
                    signature: wxConfig.signature,// 必填，签名，见附录1
                    jsApiList: ['scanQRCode']
                    // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
            },
            async getDept() {
                let res = await this.$get("/fw/getSupremeDept")
                this.deptId = res.deptId
            },
            async getWxScan() {
                let url = window.location.href
                let res = await this.$get("/fw/weixinScan", {url: url})
                if (res.code == 200) {
                    this.wxConfig = res.config
                    this.initializationWxConfig(res.config)
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            saoma () {
                let that = this;
                wx.scanQRCode({
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                        let url = res.resultStr
                        let i = url.includes('fanboshi');
                        if (i) {
                            window.location.href = url
                        } else {
                            that.$notify({type: 'danger', message: "所扫描的二维码非本系统生成二维码"});
                        }
                    },
                    fail: function (response) {
                        alert(' wx.scanQRCode失败')
                    },
                });
            },
            tologin() {
                this.$router.push('/mbinfo?deptId=' + this.deptId + '&source=PT')
                // this.$router.push('/mblogin')
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-member {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 80px;
        padding-bottom: 49px;
    }

    .member-bt {
        width: 80%;
        margin: auto;
    }

    .bty {
        display: block;
        font-size: 26px;
        font-weight: bold;
        height: 25px;
        line-height: 25px;
        text-align: center;
    }

    .mbcon {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: #EEEEEE solid 1px;
        padding-bottom: 8px;
        margin-top: 60px;
    }

    .mbtext {
        display: flex;
        flex-direction: column;
    }

    .mbtext .text1 {
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        margin-bottom: 15px;
    }

    .mbtext .text2 {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
    }

    .mbtext .text3 {
        height: 20px;
        line-height: 20px;
        font-size: 10px;
    }

    .mb-btn {
        font-size: 13px;
        background-color: #000000;
        color: #FFFFFF;
        padding: 8px 20px;
        border-radius: 30px;
        margin-top: 35px;
    }

    .zhongjian {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .zhongjian img {
        width: 100px;
        height: 100px;
        margin-top: 50px;
    }

    .saoma {
        margin-top: 25px;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
    }

    .hyzx {
        position: fixed;
        bottom: 0px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .hyzx-s {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .hyzx-s .bian {
        width: 41%;
        border-bottom: #ECECEC solid 2px;
    }

    .hyzx-s .zhong {
        width: 18%;
        border: #ECECEC solid 2px;
        border-bottom: #FFFFFF solid 2px;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 5px 0px 5px;
    }

    .hyzx-x {
        margin-top: 15px;
    }

    .hy-text {
        display: block;
        text-align: center;
        height: 30px;
        font-size: 15px;
    }

</style>